var $28c475637e01456d$exports = {};
function $28c475637e01456d$var$shuffle(array) {
    let currentIndex = array.length;
    while(currentIndex !== 0){
        let randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex],
            array[currentIndex]
        ];
    }
}
const $28c475637e01456d$var$parent = document.getElementById("quotes");
const $28c475637e01456d$var$article = $28c475637e01456d$var$parent.querySelector("article");
const $28c475637e01456d$var$quotes = [
    ...$28c475637e01456d$var$article.children
];
$28c475637e01456d$var$shuffle($28c475637e01456d$var$quotes);
$28c475637e01456d$var$article.innerHTML = "";
let $28c475637e01456d$var$fragment = document.createDocumentFragment();
const $28c475637e01456d$var$half = Math.ceil($28c475637e01456d$var$quotes.length / 2);
for(let i = 0; i < $28c475637e01456d$var$half; i++)$28c475637e01456d$var$fragment.appendChild($28c475637e01456d$var$quotes[i]);
$28c475637e01456d$var$article.appendChild($28c475637e01456d$var$fragment);
const $28c475637e01456d$var$second = document.createElement("article");
$28c475637e01456d$var$second.classList.add("quote-section", "reverse");
for(let i = $28c475637e01456d$var$half; i < $28c475637e01456d$var$quotes.length; i++)$28c475637e01456d$var$second.appendChild($28c475637e01456d$var$quotes[i]);
$28c475637e01456d$var$parent.appendChild($28c475637e01456d$var$second);


//# sourceMappingURL=index.9af451d2.js.map
